import { createContext } from 'react';

import { TimeseriesChartXAxisProps } from '../slots/XAxis.js';

export const TimeseriesXAxisConfigContext = createContext<
  TimeseriesChartXAxisProps | undefined
>(undefined);

TimeseriesXAxisConfigContext['displayName'] = 'TimeseriesXAxisConfigContext';
